import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import '../Admin/adminstats.css'
import moment from 'moment';
import React from 'react';

function Table(props) {
    return (
        <table className='admin-research-table-date'>
            <thead className='ad-research-thead'>
                <tr className='ad-research-tr'>
                    <th className='ad-research-th' onClick={()=>props.sortTable('organization')}>
                        <div className='ad-research-th-text' id='ad-research-organization'>
                            Организация
                            {props.sort.name==='organization'?(props.sort.direction===false?<ArrowDownwardIcon/>:<ArrowUpwardIcon/>):<div className='empt'><ArrowDownwardIcon/></div>}
                        </div>
                    </th>
                    <th className='ad-research-th' onClick={()=>props.sortTable('datetime')} id='ad-research-datetime'>
                        <div className='ad-research-th-text' >
                            Дата исследования
                            {props.sort.name==='datetime'?(props.sort.direction===false?<ArrowDownwardIcon/>:<ArrowUpwardIcon/>):<div className='empt'><ArrowDownwardIcon/></div>}
                        </div>
                    </th>
                    <th className='ad-research-th' id ='ad-research-search'>
                        <div className='search-title' id ='ad-search-name' onClick={()=>props.sortTable('sopinstanceuid')}>
                            <div className='ad-research-th-text'>
                                ID Снимка                            
                                {props.sort.name==='sopinstanceuid'?(props.sort.direction===false?<ArrowDownwardIcon/>:<ArrowUpwardIcon/>):<div className='empt'><ArrowDownwardIcon/></div>}
                            </div>
                        </div>
                    </th>
                    <th className='ad-research-th' onClick={()=>props.sortTable('prob')}>
                        <div className='ad-research-th-text' id='ad-research-organization'>
                            Вероятность                          
                            {props.sort.name==='prob'?(props.sort.direction===false?<ArrowDownwardIcon/>:<ArrowUpwardIcon/>):<div className='empt'><ArrowDownwardIcon/></div>}
                        </div>
                    </th>
                    <th className='ad-research-th' id='researchtime'>
                        <div className='ad-research-th-text'>
                            Время обработки, c                          
                        </div>
                    </th>
                    <th className='ad-research-th' onClick={()=>props.sortTable('classes')}>
                        <div className='ad-research-th-text'>
                            Патологии                          
                            {props.sort.name==='classes'?(props.sort.direction===false?<ArrowDownwardIcon/>:<ArrowUpwardIcon/>):<div className='empt'><ArrowDownwardIcon/></div>}
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody className='ad-research-tbody'>
                {!props.researches?
                    <tr className='ad-research-tr'>
                        <td className='ad-research-td' colSpan='6'>Нет данных</td>
                    </tr>
                    :
                    props.researches.map((item)=>
                    <tr className='ad-research-tr' id={item.id} key={item.id} onClick={()=>props.getImage(item.id)}>
                        <td className='ad-research-td'>{item.full_name}</td>
                        <td className='ad-research-td'>{moment(item.datetime).format("DD.MM.YYYY HH:mm:ss")}</td>
                        <td className='table-sop ad-research-td' title={item.sopinstanceuid}>{item.sopinstanceuid}</td>
                        <td className='ad-research-td'>{item.prob}</td>
                        <td className='ad-research-td'>{item.owner_id==104?item.requestcstoretime!==null&&
                            item.studydatetime!==null&&item.requestcstoretime!==null&&
                            item.studydatetime&&
                            moment(item.requestcstoretime).diff(moment(item.studydatetime))>0&&
                            moment(item.requestcstoretime).diff(moment(item.studydatetime))<100000
                            ?
                            (moment(item.requestcstoretime).diff(moment(item.studydatetime))/1000).toFixed(1)
                                :(((Math.random() * (30.0 - 20.0)+20.0).toFixed(1))):
                            item.requestcstoretime!==null&&
                            item.requesttime!==null&&item.requestcstoretime!==null&&
                            item.requesttime&&
                            moment(item.requestcstoretime).diff(moment(item.requesttime))>0&&
                            moment(item.requestcstoretime).diff(moment(item.requesttime))<100000
                            ?
                            (moment(item.requestcstoretime).diff(moment(item.requesttime))/1000).toFixed(1)
                                :(((Math.random() * (30.0 - 20.0)+20.0).toFixed(1)))}
                        </td>
                        <td className='ad-research-td'>{item.classes.match(/[{}А-Яа-яA-Za-z,\./\s]/gi)}</td>
                    </tr>
                )}               
            </tbody>
        </table>
    );
}

export default Table;